import { NextSeo } from 'next-seo';
import dynamic from 'next/dynamic';
import React from 'react';
import { Toaster } from 'react-hot-toast';
import Alert from '../components/Alert';
import Container from '../components/Container';
import PageHeader from '../components/PageHeader';
import { config } from '../config';

const TheMissions = dynamic(() => import('../components/TheMissions'), { ssr: false });

function Missions() {
  const description = `Send your Brats on missions based on their element to earn great rewards.`;

  return (
    <>
      <NextSeo title={`Missions - ${config.collectionName}`} description={description} />
      <PageHeader title='Missions' description={description} image='/heepows/tree.png' />

      <TheMissions />

      {/* <div className='mt-24 pb-48'>
        <Container>
          <div className='max-w-lg mx-auto flex justify-center text-center'>
            <Alert type='danger'>
              Missions are currently under maintenance. <br></br>Please check back later
            </Alert>
          </div>
        </Container>
      </div> */}

      <Toaster position='bottom-center' />
    </>
  );
}

export default Missions;
